import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-2" }
const _hoisted_2 = { class: "text-[10px]" }


export default /*@__PURE__*/_defineComponent({
  __name: 'IconsSwatch',
  setup(__props) {

const iconClasses = [
  'bg-login-icon',
  'bg-calendar-icon',
  'bg-step-completed-icon',
  'bg-datepicker-calendar-icon',
  'bg-datepicker-prev-icon',
  'bg-datepicker-next-icon',
  'bg-warnning-icon',
  'bg-tag-icon',
  'bg-document-icon',
  'bg-pet-icon',
  'bg-payment-filled-icon',
  'bg-house-icon',
  'bg-home-icon',
  'bg-content-icon',
  'bg-user-icon',
  'bg-phone-icon',
  'bg-car-icon',
  'bg-car-filled-icon',
  'bg-shopping-bag-icon',
  'bg-battery-icon',
  'bg-movie-ticket-icon',
  'bg-icon-success',
  'bg-icon-warning',
  'bg-icon-danger',
  'bg-icon-info',
  'bg-icon-bank-account',
  'bg-icon-active',
  'bg-icon-cancelled',
  'bg-icon-mastercard',
  'bg-icon-check',
  'bg-icon-star',
  'bg-icon-chevron-down',
  'bg-icon-arrow-down',
  'bg-icon-chevron',
  'bg-icon-small-nextTick',
  'bg-icon-small-cross',
  'bg-date-icon',
  'bg-dollar-filled-icon',
  'bg-dollar-filled-circle-icon',
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(iconClasses, (icon) => {
      return _createElementVNode("div", {
        key: icon,
        class: "flex flex-col w-[126px] h-[126px] border border-solid border-racq-white justify-center items-center text-center"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([['icon', icon], "w-[100%] h-[100%] !bg-no-repeat !bg-center mb-1"])
        }, null, 2),
        _createElementVNode("p", _hoisted_2, _toDisplayString(icon), 1)
      ])
    }), 64))
  ]))
}
}

})